export const VALIDATE_RULES = {
  required: {
    required: "This field is required",
    minLength: { value: 1, message: "Please enter at least 1 character" },
    maxLength: {
      value: 150,
      message: "Please enter no more than 150 characters",
    },
  },
  password: {
    required: "Password is required",
    pattern: {
      value: /^\S*$/,
      message: "No spaces allowed",
    },
    minLength: {
      value: 1,
      message: "Please enter at least 1 character",
    },
  },
  number: {
    required: "Please enter a number",
    pattern: {
      value: /^[1-9][0-9]*$/,
      message: "Only numbers are allowed",
    },
  },
  numberOnly: {
    required: "Please enter a number",
    pattern: {
      value: /^[0-9]+$/,
      message: "Please enter a number containing only digits 0 to 9",
    },
  },
  phoneNumber: {
    required: "Phone number is required",
    pattern: {
      value: /^0[1-9][0-9]{8}$/gm,
      message: "Please enter a phone number",
    },
  },
  email: {
    required: "Email is required",
    pattern: {
      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Please enter a valid email address",
    },
  },
  dropDown: {
    required: "Please select from the dropdown",
  },
};
